import {skills} from "../types/jobDataTypes";
import {defaultFadeDuration, minAudioFadeDuration} from "./constants";
import {
    defaultOpenerCloserObject
} from "../components/CommonComponents/OpenerCloserComponent/OpenerCloserContentComponent";
import {SupportedSports} from "../types/generic";

const FootballEventsOfInterest =
    [
        {
            key_moment: "START",
            start: -31,
            end: 31,
            replay: false,
            included: true,
            var: false,
            auto_publication: false,
        },
        {
            key_moment: "GOAL",
            start: -31,
            end: 31,
            replay: false,
            included: true,
            var: true,
            auto_publication: false,
        },
        {
            key_moment: "SAVE",
            start: -31,
            end:31,
            replay: false,
            included: true,
            var: false,
            auto_publication: false,
        },
        {
            key_moment: "MISS",
            start: -31,
            end: 31,
            replay: false,
            included: true,
            var: false,
            auto_publication: false,
        },
        {
            key_moment: "CARD",
            start: -31,
            end: 31,
            replay: false,
            included: true,
            var: true,
            auto_publication: false,
        },
        {
            key_moment: "END",
            start: -31,
            end: 31,
            replay: false,
            included: true,
            var: false,
            auto_publication: false,
        },
    ]
const FootballSkills = [
    {
        key_moment: skills.SKILL_PASS,
        start: -31,
        end: 31,
        included: false,
        var: false,
        replay: false,
        auto_publication: false,
    },
    {
        key_moment: skills.SKILL_TACKLE,
        start: -31,
        end: 31,
        included: false,
        var: false,
        replay: false,
        auto_publication: false,
    },
    {
        key_moment: skills.SKILL_SAVE,
        start: -31,
        end: 31,
        included: false,
        var: false,
        replay: false,
        auto_publication: false,
    },
    {
        key_moment: skills.SKILL_SHOT,
        start: -31,
        end: 31,
        included: false,
        var: false,
        replay: false,
        auto_publication: false,
    },
    {
        key_moment: skills.SKILL_CROSS,
        start: -31,
        end: 31,
        included: false,
        var: false,
        replay: false,
        auto_publication: false,
    },
    {
        key_moment: skills.SKILL_DRIBBLING,
        start: -31,
        end: 31,
        included: false,
        var: false,
        replay: false,
        auto_publication: false,
    },
    {
        key_moment: skills.SKILL_GOOD_SKILL,
        start: -31,
        end: 31,
        included: false,
        var: false,
        replay: false,
        auto_publication: false,
    },
    {
        key_moment: skills.SKILL_GOAL,
        start: -31,
        end: 31,
        included: false,
        var: false,
        replay: false,
        auto_publication: false,
    },
    {
        key_moment: skills.SKILL_ASSIST,
        start: -31,
        end: 31,
        included: false,
        var: false,
        replay: false,
        auto_publication: false,
    },
    {
        key_moment: skills.SKILL_HEAD,
        start: -31,
        end: 31,
        included: false,
        var: false,
        replay: false,
        auto_publication: false,
    },
    {
        key_moment: skills.SKILL_SET_PIECE,
        start: -31,
        end: 31,
        included: false,
        var: false,
        replay: false,
        auto_publication: false,
    },
    {
        key_moment: skills.SKILL_GOAL_FRAME,
        start: -31,
        end: 31,
        included: false,
        var: false,
        replay: false,
        auto_publication: false,
    }
]

const BasketBallEventsOfInterest = [
    {
        key_moment: "START",
        start: -31,
        end: 31,
        included: true,
        auto_publication: false,
    },
    {
        key_moment: "THREE_POINTS",
        start: -31,
        end: 31,
        included: true,
        auto_publication: false,
    },
    {
        key_moment: "BLOCK",
        start: -31,
        end:31,
        included: true,
        auto_publication: false,
    },
    {
        key_moment: "FREETHROW",
        start: -31,
        end: 31,
        included: true,
        auto_publication: false,
    },
    {
        key_moment: "TWO_POINTS",
        start: -31,
        end: 31,
        included: true,
        auto_publication: false,
    },
    {
        key_moment: "DUNK",
        start: -31,
        end: 31,
        included: true,
        auto_publication: false,
    },
    {
        key_moment: "END",
        start: -31,
        end: 31,
        included: true,
        auto_publication: false,
    },
]

const basketballHighlightSettings = [
    {
        type: 'Regular',
        opener: defaultOpenerCloserObject,
        closer: defaultOpenerCloserObject,
        fade: false,
        fade_duration: minAudioFadeDuration
    },
    {
        type: 'Fast',
        opener: defaultOpenerCloserObject,
        closer: defaultOpenerCloserObject,
        music: {
            filename: '',
            src: '',
            label: ''
        }
    },
    {
        type: 'Pistolero',
        opener: defaultOpenerCloserObject,
        closer: defaultOpenerCloserObject,
        fade: false,
        fade_duration: minAudioFadeDuration
    }
]

const footballHighlightSettings = [
    {
        type: 'Regular',
        opener: defaultOpenerCloserObject,
        closer: defaultOpenerCloserObject,
        fade: false,
        fade_duration: defaultFadeDuration
    },
]

const SettingSportDict = {
    eventOfInterest:{
        football: FootballEventsOfInterest,
        basketball: BasketBallEventsOfInterest,
    },
    skills: {
        football: FootballSkills,
        basketball: []
    }
}


const HighlightSettingsDict = {
    football: footballHighlightSettings,
    basketball: basketballHighlightSettings
}

export function getDefaultDataJob(){
    const sport = process.env.REACT_APP_SPORT as SupportedSports
    return {
        name: "",
        description: "",
        extraction_schedule: new Date(),
        job_base_folder: "",
        llm_generation: true,
        tag: [],
        target: "clipping",
        push_schedule: null,
        settings: {
            events_of_interest: SettingSportDict.eventOfInterest[sport],
            offset: 5,
            skills: SettingSportDict.skills[sport]
        },
        highlights_settings: HighlightSettingsDict[process.env.REACT_APP_SPORT as SupportedSports],
        data_sources: [],
        tracks: [],
        events: {
            id: ""
        },
        hooks: [],
        kafka_hook: false
    }
}